var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoX(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "ionicon",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Logo X") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m298.73602,229.89639l161.22032,-183.89638l-38.1906,0l-140.04663,159.64201l-111.77173,-159.64201l-128.94739,0l169.05762,241.42998l-169.05762,192.82001l38.1906,0l147.79732,-168.6235l118.06466,168.6235l128.94739,0m-381.02554,-405.9894l58.6715,0l270.09095,379.11724l-58.68593,0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoX);
export default __webpack_public_path__ + "static/media/logo-x.04784e9f4b85b110682e796c4392578c.svg";
export { ForwardRef as ReactComponent };